import React, { useEffect } from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import CartDrawer from '../components/cart/CartDrawer';
import { Link } from 'react-router-dom';
import { Shield, CheckCircle2, Award, ArrowRight } from 'lucide-react';
import { siteImages } from '../data/mock';

const QualityGuaranteePage = () => {
  useEffect(() => { document.title = 'Quality Guarantee | Tool Supply Point'; }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <CartDrawer />

      <main>
        <section className="relative h-64 md:h-80 overflow-hidden bg-dark-900">
          <img src={siteImages.featuredBackground} alt="Quality guarantee" className="absolute inset-0 w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-r from-dark-900 via-dark-900/85 to-dark-900/40" />
          <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-athletic-600/15 border border-athletic-600/30 rounded-sm text-athletic-400 text-xs font-bold uppercase tracking-widest mb-4">
                <Shield className="w-3.5 h-3.5" /> Our Commitment
              </div>
              <h1 className="font-display text-4xl md:text-5xl text-white font-bold uppercase mb-3">Quality Guarantee</h1>
              <p className="text-dark-200 max-w-lg">Our commitment to shipping tools you can put straight to work.</p>
            </div>
          </div>
        </section>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="bg-dark-50 border border-dark-200 rounded-sm p-8 md:p-12 mb-16 text-center">
            <div className="w-20 h-20 bg-athletic-600 rounded-sm flex items-center justify-center mx-auto mb-6">
              <Award className="w-10 h-10 text-white" />
            </div>
            <h2 className="font-display text-3xl lg:text-4xl text-dark-900 font-bold uppercase mb-6">Our quality promise</h2>
            <p className="text-dark-600 text-lg leading-relaxed max-w-3xl mx-auto">
              At Tool Supply Point, we stand behind every tool we sell. We hand-select and vet all of our hardware to make sure it meets our standards for power, build quality and value. If a tool isn&apos;t right for you, we&apos;ll make it right.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-16">
            {[
              { icon: Shield, title: 'Vetted Tools', desc: 'Every tool is checked for build quality and performance before it ever ships.' },
              { icon: CheckCircle2, title: '30-Day Returns', desc: 'Not satisfied? Return any unused tool within 30 days for a full refund.' },
              { icon: Award, title: 'Pro-Grade Quality', desc: 'We only list tools that clear our strict standard for durability.' },
            ].map((item, i) => (
              <div key={i} className="bg-dark-50 border border-dark-200 rounded-sm p-6 text-center hover:border-athletic-400 transition-all group">
                <div className="w-14 h-14 bg-athletic-50 rounded-sm flex items-center justify-center mx-auto mb-4 group-hover:bg-athletic-100 transition-colors">
                  <item.icon className="w-7 h-7 text-athletic-700" />
                </div>
                <h3 className="font-display font-bold uppercase text-dark-900 text-lg mb-2">{item.title}</h3>
                <p className="text-dark-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="bg-dark-50 border border-dark-200 rounded-sm p-8 md:p-12 mb-16">
            <h2 className="font-display text-2xl font-bold uppercase text-dark-900 mb-8 text-center">What we guarantee</h2>
            <div className="grid md:grid-cols-2 gap-6">
              {[
                'Tools exactly as described on our website',
                'Genuine components and solid build quality',
                'Fast, secure shipping',
                '30-day money-back guarantee',
                'Secure payment processing',
                'Responsive customer support',
                'Authentic products, no counterfeits',
                'Safe packaging and handling',
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3 p-4 bg-white rounded-sm border border-dark-200">
                  <CheckCircle2 className="w-5 h-5 text-athletic-600 flex-shrink-0" />
                  <span className="text-dark-900 font-medium">{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="text-center bg-gradient-athletic rounded-sm p-12">
            <h2 className="font-display text-3xl font-bold uppercase text-white mb-4">Buy with confidence</h2>
            <p className="text-white/90 mb-8 max-w-xl mx-auto">Feel our commitment to quality. Every order is backed by our satisfaction guarantee.</p>
            <Link to="/shop" className="inline-flex items-center gap-2 px-8 py-4 bg-dark-900 text-white font-bold uppercase tracking-wider rounded-sm hover:bg-dark-800 transition-all">Shop Now <ArrowRight className="w-5 h-5" /></Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default QualityGuaranteePage;
